export class Carousel {
    constructor() {
        const animationDuration = 1000;
        const animationInterval = 10000;

        document.addEventListener("DOMContentLoaded", (event) => {
            $(".carousel > div:gt(0)").hide();

            setInterval(() => {
                $(".carousel > div:first")
                    .fadeOut(animationDuration)
                    .next()
                    .fadeIn(animationDuration)
                    .end()
                    .appendTo(".carousel");
            }, animationInterval);
        });
    }
}

// needed on all pages
if (/\/?$/i.test(location.pathname)) {
    const carouselWindow = window as any;
    carouselWindow.carousel = new Carousel();
}
